import { h, Component } from 'preact';
import { observer } from 'mobx-preact';
import linkstate from 'linkstate';

import util from '../../lib/util';
import style from './style.css';

@observer
class Item extends Component {
    imageServer = util.getImageServer();

    uniqId = util.randomPassword();

    selectAndCopy = (event) => {
        event.target.select();
        document.execCommand('copy');
        this.setState({ selected: true });
        this.removeSelectText();
    }

    removeSelectText() {
        this.selectTimer = setTimeout(() => {
            this.setState({ selected: false });
        }, 2000);
    }

    render() {
        const { data, imagePrefix = 'product', ...props } = this.props;
        const { selected, title = '', text = '', size = '800x' } = this.state;

        let imageName = `${imagePrefix}_${data.sort}_${data.filename}.${data.ext}`;
        if (data.newFilename) {
            imageName = data.newFilename;
        }

        return (
            <li class={`item mb-2`} {...props}>
                <div class='row'>
                    <div class='col-2'>
                        <img class='img-fluid' src={`${this.imageServer}/220x/${imageName}`} ondragstart={e => e.preventDefault()} />
                    </div>
                    <div class='col-10'>
                        {imageName}<br />
                        {data && ['name', 'mimetype'].map(key => <li style='line-height: .9em;'>
                            {data[key] && <small class='font-weight-lighter'>
                                {key}: {data[key]}
                            </small>}
                        </li>)}
                        <div class='row mb-1'>
                            <div class='col-3'>
                                <input class='form-control form-control-sm' oninput={linkstate(this, 'title')} placeholder='Enter image title' />
                            </div>
                            <div class='col-9'>
                                <input class='form-control form-control-sm' oninput={linkstate(this, 'text')} placeholder='Enter image text' />
                            </div>
                            <div class='col-12'>
                                {['80x80', '150x', '220x', '400x', '800x', '1024x', '1280x'].map(toggleSize => (
                                    <div class='form-check form-control-sm form-check-inline'>
                                        <input class='form-check-input' type='radio' name='size' id={`size${toggleSize}${this.uniqId}`} value={`${toggleSize}`} onchange={linkstate(this, 'size', 'target.value')} />
                                        <label class='form-check-label' for={`size${toggleSize}${this.uniqId}`}>
                                            {toggleSize}
                                        </label>
                                    </div>
                                ))}
                            </div>
                        </div>
                        
                        <input class='form-control form-control-sm' value={`![${title}](${this.imageServer}/${size}/${imageName} "${text}")`}
                            onClick={this.selectAndCopy}
                        />
                        {selected && <div class={`valid-feedback`} style='display: block;'>
                            Text copied to clipboard...
                        </div>}
                    </div>
                </div>
            </li>
        );
    }
}

@observer
class ImageList extends Component {
    render() {
        const {
            name,
            value,
            help,
        } = this.props;
        const items = util.makeArrayOfObject(value);

        return (
            <div class='row'>
                <div class='col-12'>
                    <ul class={`${style.list} px-0`}>
                        {items.map(item => <Item
                            data={item}
                            {...this.props}
                        />)}
                    </ul>
                </div>
                <small id={`${name}Help`} class='form-text text-muted'>
                    <small class='float-right text-info ml-2'>"{util.getType(value)}"</small>
                    <small class='float-right'>"{name}"</small>
                    {help}
                </small>
            </div>
        );
    }
}

export default ImageList;



// WEBPACK FOOTER //
// ./components/form/imagelist.js